import { toPairs } from 'lodash';
export interface IQueryParams {
  [key: string]: string | undefined;
}

export function parseQueryParams(search: string): IQueryParams {
  return search
    .split('&')
    .map(pair => pair.split('='))
    .reduce((acc, [key, value]) => (key ? { ...acc, [key]: value } : acc), {});
}

export function stringifyQueryParams(query: IQueryParams): string {
  return toPairs(query)
    .filter(pair => pair[1] !== undefined)
    .map(pair => pair.join('='))
    .join('&');
}

export function getSearch(query: IQueryParams) {
  const queryString = stringifyQueryParams(query);

  return queryString ? `?${queryString}` : '';
}

export type LocationDescriptor = {
  query?: IQueryParams;
  hash?: string;
};

export type PlainLocationDescriptor = {
  query: string;
  hash: string;
};

export function mergeStates(descriptors: LocationDescriptor[], options: { mergeQuery?: boolean } = {}) {
  return descriptors.reduce(
    (acc, x) => ({
      hash: x.hash || acc.hash,
      query: options.mergeQuery ? Object.assign(acc.query || {}, x.query || {}) : x.query || acc.query,
    }),
    {},
  );
}
